export default __webpack_public_path__ + "static/media/step_A.617b5431.png";